import React from 'react';
import { Box, Container, Typography, Paper, Button } from '@mui/material';
import { Cancel } from '@mui/icons-material';
import Navigation from '../components/Navigation';
import { useNavigate } from 'react-router-dom';

const CancelPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: 'background.default' }}>
      <Navigation />
      
      <Box sx={{ pt: 12, pb: 8 }}>
        <Container maxWidth="md">
          <Paper
            sx={{
              p: 6,
              bgcolor: 'rgba(255, 193, 7, 0.1)',
              border: '3px solid #FFC107',
              borderRadius: 4,
              textAlign: 'center',
            }}
          >
            <Cancel 
              sx={{ 
                fontSize: 80, 
                color: '#FFC107', 
                mb: 3 
              }} 
            />
            
            <Typography
              variant="h3"
              gutterBottom
              sx={{ color: 'text.primary', mb: 3, fontWeight: 'bold' }}
            >
              Payment Cancelled
            </Typography>

            <Typography
              variant="h6"
              sx={{ color: 'text.secondary', mb: 4, lineHeight: 1.5 }}
            >
              No worries! Your payment was cancelled and you haven't been charged.
            </Typography>

            <Box sx={{ 
              bgcolor: 'rgba(136, 192, 208, 0.1)', 
              border: '2px solid #88C0D0',
              borderRadius: 2,
              p: 4,
              mb: 4 
            }}>
              <Typography variant="h6" sx={{ color: 'secondary.main', mb: 2 }}>
                Still interested?
              </Typography>
              <Typography variant="body1" sx={{ color: 'text.primary', mb: 2 }}>
                • The offer is still available whenever you're ready
              </Typography>
              <Typography variant="body1" sx={{ color: 'text.primary', mb: 2 }}>
                • Join our $7 community to get access for free
              </Typography>
              <Typography variant="body1" sx={{ color: 'text.primary' }}>
                • Questions? Feel free to reach out anytime
              </Typography>
            </Box>

            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
              <Button
                variant="contained"
                color="secondary"
                size="large"
                onClick={() => navigate(-1)}
                sx={{
                  color: 'black',
                  py: 2,
                  px: 4,
                  fontWeight: 'bold',
                  fontSize: '1.1rem',
                  '&:hover': { transform: 'scale(1.02)' },
                  transition: 'transform 0.2s',
                }}
              >
                Try Again
              </Button>
              
              <Button
                variant="outlined"
                color="secondary"
                size="large"
                onClick={() => navigate('/')}
                sx={{
                  py: 2,
                  px: 4,
                  fontWeight: 'bold',
                  fontSize: '1.1rem',
                  borderWidth: 2,
                  '&:hover': { 
                    borderWidth: 2,
                    transform: 'scale(1.02)' 
                  },
                  transition: 'transform 0.2s',
                }}
              >
                Back to Home
              </Button>
            </Box>
          </Paper>
        </Container>
      </Box>
    </Box>
  );
};

export default CancelPage;